import { useContext } from "react";
import { ZoneContext } from "../views/Game.tsx";
import { Box, Callout } from "@radix-ui/themes";
import { GlobeIcon } from "@radix-ui/react-icons";

const LocationBar = () => {
  const [zoneContext] = useContext(ZoneContext);
  return (
    <Box
      style={{
        display: "inline-block",
        position: "fixed",
        left: "5px",
        top: "5px",
        opacity: "0.70",
      }}
    >
      {zoneContext.currentZone && (
        <Callout.Root
          size={"1"}
          variant={"outline"}
          style={{
            backgroundColor: "black",
            padding: "9px",
            borderColor: "var(--ro-accent)" // Gold highlight color for border
          }}
        >
          <Callout.Icon style={{ color: "var(--ro-text)" }}>
            <GlobeIcon />
          </Callout.Icon>
          <Callout.Text style={{ color: "var(--ro-text)" }}>{zoneContext.currentZone}</Callout.Text>
        </Callout.Root>
      )}
    </Box>
  );
};

export { LocationBar };
